import { TransferHttpCacheModule } from '@nguniversal/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepartmentComponent } from './department.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorInterceptor, JwtInterceptor } from '../common/_helpers';
import { ApiService } from '../common/api-service/api.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  declarations: [DepartmentComponent],
  imports: [
    TransferHttpCacheModule,
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: DepartmentComponent,
        children: [
         
          {
            path: '',
            loadChildren: () =>
              import(
                './e-laboratory-survey-room/e-laboratory-survey-room.module'
              ).then((m) => m.ELaboratorySurveyRoomModule),
          },
          
        ],
      },
    ]),
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [   
    ApiService
  ],
})
export class DepartmentModule { }
